import { createStore, applyMiddleware } from 'redux';
import * as thunk from 'redux-thunk';
import { reducers } from '../models';
import { isDev } from '../config';
import { composeWithDevTools } from 'redux-devtools-extension';

const configureStore = (preloadedState) => {
    const middlewares = [thunk.default];
    let applys = applyMiddleware(...middlewares);
    if (isDev) {
        const composeEnhansers = composeWithDevTools({ realtime:true });
        applys = composeEnhansers(applys);
    }
    return createStore(
        reducers,
        preloadedState,
        applys
    );
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.js